import { ReactNode } from "react";

export default function RenderWhen(props: {
    component: ReactNode;
    condition: boolean;
}): JSX.Element {
    if (props.condition) {
        return <>{props.component}</>;
    } else {
        return <></>;
    }
}
